// Segmented, front-loaded progress — one segment per assessment. Front-loading
// (pow 0.6) makes the early taps feel like fast momentum. Mirrors the prototype.

const CONTENT = new Set(['question', 'scale']);
const SECONDS_PER_SCREEN = 6;

export function computeProgress(screens, cur) {
  const contentByA = [0, 0, 0];
  let contentTotal = 0;
  for (const s of screens) {
    if (CONTENT.has(s.type)) {
      contentByA[s.assessment] += 1;
      contentTotal += 1;
    }
  }

  const s = screens[cur] || {};
  const curA = s.type === 'done' ? 3 : s.type === 'secure' ? 0 : s.assessment ?? 0;

  const doneA = [0, 0, 0];
  let doneTotal = 0;
  for (let i = 0; i < cur; i += 1) {
    const sc = screens[i];
    if (CONTENT.has(sc.type)) {
      doneA[sc.assessment] += 1;
      doneTotal += 1;
    }
  }

  const segments = [0, 1, 2].map((a) => {
    if (a < curA) return 1;
    if (a > curA) return 0;
    return contentByA[a] ? doneA[a] / contentByA[a] : s.type === 'done' ? 1 : 0;
  });

  const front = contentTotal ? Math.pow(doneTotal / contentTotal, 0.6) : 0;
  const pct = s.type === 'done' ? 100 : Math.round(front * 100);
  const remain = contentTotal - doneTotal;
  const minsLeft = s.type === 'done'
    ? 0
    : Math.max(1, Math.round((remain * SECONDS_PER_SCREEN) / 60));

  return { segments, pct, minsLeft, curA };
}
